/** BookingsCardHeader — the "BOOKINGS" label + pacing pill + Check-in CTA
 *  (BON-197/BON-204, extracted BON-490). The pill shows only for an active +
 *  future workshop (Axis B) — past/draft/cancelled show none here, since the
 *  lifecycle status lives in the page header. */
import type { Workshop } from '../../../../api/workshops';
import { StatusPill } from '../../primitives';
import { paceToStatus } from '../../venues/detail/upcomingWorkshopsFormat';

import { AddTreeReplacementButton } from './AddTreeReplacementButton';
import type { BookingsPacing } from './bookingsCardTypes';
import { CheckInButton } from './CheckInButton';
import { labelStyle } from './workshopFields';

function isActiveFuture(pacing: BookingsPacing, now: Date): boolean {
  return pacing.lifecycle === 'active' && new Date(pacing.startsAt).getTime() >= now.getTime();
}

export function BookingsCardHeader({
  pacing,
  now,
  onOpenCheckIn,
  addTreeReplacement,
}: {
  pacing?: BookingsPacing;
  now: Date;
  onOpenCheckIn?: () => void;
  /** Given only for people who may manage tree replacements. */
  addTreeReplacement?: { workshopId: string; onOpen: () => void };
}) {
  const pace: Workshop['paceStatus'] | undefined = pacing?.paceStatus;
  return (
    <div
      className="nb-card-hd"
      style={{
        marginBottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
      }}
    >
      <h3 style={labelStyle}>BOOKINGS</h3>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {pacing && isActiveFuture(pacing, now) && (
          <StatusPill tone={paceToStatus(pace).tone} label={paceToStatus(pace).label} />
        )}
        {addTreeReplacement && <AddTreeReplacementButton {...addTreeReplacement} />}
        {onOpenCheckIn && <CheckInButton onOpen={onOpenCheckIn} />}
      </div>
    </div>
  );
}
